<div class="container-fluid mt-3">
  <div class="d-flex align-items-center mb-1">
    <h2 class="mb-0 mr-3">Cancellation Policy Viewer</h2>
    <button class="btn btn-outline-secondary btn-sm" (click)="showHelp = !showHelp">
      <span>&#9432;</span>&nbsp;{{ showHelp ? 'Hide' : 'How It Works' }}
    </button>
  </div>
  <p class="text-muted mb-2">Enter a reservation ID to evaluate the dynamic cancellation policy that would apply if this reservation were cancelled right now.</p>

  <!-- How It Works panel -->
  <div *ngIf="showHelp" class="help-panel mb-3">
    <h5 class="help-title">Dynamic Cancellation Policy — Decision Tree</h5>
    <p class="mb-2 text-muted" style="font-size:0.9em;">The engine evaluates four tiers in order. The <strong>first match wins</strong>.</p>

    <div class="help-tier">
      <span class="help-tier-num">1</span>
      <div>
        <strong>Manual Override</strong> — admin decision always wins, bypasses all logic.
      </div>
    </div>

    <div class="help-tier">
      <span class="help-tier-num">2</span>
      <div>
        <strong>Global Grace Period</strong> — guest cancelled within <strong>72 hours</strong> of booking.
        → <span class="text-success font-weight-bold">Full Refund Minus Fees</span>, regardless of check-in date.
      </div>
    </div>

    <div class="help-tier">
      <span class="help-tier-num">3</span>
      <div>
        <strong>Flexible Policy</strong> — activates only when <em>all four</em> conditions hold simultaneously:
        <ul class="mt-1 mb-1">
          <li>Check-in is within <strong>14 days</strong></li>
          <li>14-day occupancy for this unit is <strong>under 60%</strong></li>
          <li>Property "Flexible Policy Eligible" toggle is <strong>ON</strong></li>
          <li>Rate season "Flexible Policy Eligible" toggle is <strong>ON</strong></li>
        </ul>
        Outcome: ≥7 days before check-in → <strong>Half Refund</strong> &nbsp;|&nbsp; &lt;7 days → <strong>No Refund</strong><br/>
        <span class="text-danger" style="font-size:0.85em;">Never activates during restricted seasons: Christmas Hawaii, New Year Hawaii, Holiday Utah, New Year Utah, High Winter Utah.</span>
      </div>
    </div>

    <div class="help-tier">
      <span class="help-tier-num">4</span>
      <div>
        <strong>Standard Strict</strong> — default when Flexible does not apply:
        <table class="help-table mt-1">
          <tr><td>&gt;90 days before check-in</td><td class="text-success font-weight-bold">Full Refund Minus Fees</td></tr>
          <tr><td>45–90 days before check-in</td><td class="text-warning font-weight-bold">Half Refund</td></tr>
          <tr><td>&lt;45 days before check-in</td><td class="text-danger font-weight-bold">No Refund</td></tr>
        </table>
      </div>
    </div>

    <div class="help-note mt-2">
      <strong>Managing toggles:</strong> Go to a property's edit form or a Rate Bucket's edit form to turn the Flexible toggle ON or OFF.
      Turn OFF to permanently lock a property or season to Standard Strict.
      All decisions (from this viewer and from live cancellations) are logged automatically to the audit table.
    </div>
  </div>

  <!-- Search bar -->
  <div class="row align-items-end mb-2">
    <div class="col-md-3">
      <label for="reservationIdInput">Reservation ID</label>
      <input id="reservationIdInput"
             type="number"
             class="form-control"
             [(ngModel)]="reservationId"
             placeholder="e.g. 12345"
             (keyup.enter)="search()" />
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary" (click)="search()" [disabled]="loading || !reservationId">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Evaluate Policy
      </button>
    </div>
  </div>

  <!-- No result yet -->
  <div *ngIf="searched && !decision" class="alert alert-warning mt-3">
    No policy decision returned for reservation {{ reservationId }}. Check that the reservation ID is valid.
  </div>

  <!-- Result card -->
  <div *ngIf="decision" class="policy-card">

    <div class="row mb-3">
      <div class="col-md-6">
        <h4>
          Policy:&nbsp;
          <span class="badge" [ngClass]="policyBadgeClass(decision.policyName)">
            {{ decision.policyDisplayName || decision.policyName }}
          </span>
        </h4>
        <h5 class="mt-2">
          Refund Outcome:&nbsp;
          <span class="badge" [ngClass]="refundBadgeClass(decision.refundOutcome)">
            {{ decision.refundOutcome?.replace('_', ' ') }}
          </span>
        </h5>
        <p *ngIf="decision.overrideApplied" class="text-danger font-weight-bold mt-1">
          &#9888; Manual override was applied.
        </p>
      </div>
    </div>

    <div class="reasoning-box">
      <strong>Reasoning:</strong> {{ decision.reasoning }}
    </div>

  </div>
</div>
